import api from "./client";

/* Fetch values based on type */
export const fetchLabelValues = (type, shipper) =>
  api.get("/api/labels/options", {
    params: { type, shipper }
  });

/* Generate printable labels */
export const generateLabels = (payload) =>
  api.post("/api/labels/print", payload, {
    responseType: "blob"
  });

export const generateZplFile = (payload) =>
  api.post("/api/labels/print-zpl", payload, {
    responseType: "blob"
  });
  

export const fetchShippers = () =>
  api.get("/api/labels/shippers");
